/**
 * Copyright (c) 2025, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./StatsBoard.css";

// The head of both money-facing sections: four KPI tiles, twelve months of
// bars, and the two-way split underneath. The nonprofit reads it as "where
// the money came from", the business as "what our sales gave".
class StatsBoard extends Component {
  render() {
    const d = this.props.data;
    const m = this.props.m;
    return (
      <React.Fragment>
        <div className="Marketplace-Kpis">
          {d.kpis.map((k) => (
            <div className="Marketplace-card Marketplace-Kpi" key={k.id}>
              <div className="Marketplace-cardTitle">{k.label}</div>
              <div className="Marketplace-Kpi-value">{k.value}</div>
              <div className="Marketplace-Kpi-note" style={{ color: k.noteColor }}>
                {k.note}
              </div>
            </div>
          ))}
        </div>

        <div className="Marketplace-StatsBoard">
          <div className="Marketplace-card">
            <div className="Marketplace-cardHead">
              <span className="Marketplace-cardTitle">{d.chartTitle}</span>
              {/* A donor's scale is not a nonprofit's, so the caller can name
                  its own unit and only falls back to the shared one. */}
              <span className="Marketplace-cardNote">{d.chartUnit || m.chartUnit}</span>
            </div>
            {d.chartEmpty && <div className="Marketplace-empty">{d.emptyLabel}</div>}
            <div className="Marketplace-Chart">
              {d.chart.map((t) => (
                <div className="Marketplace-Chart-col" key={t.m}>
                  <div className="Marketplace-Chart-bar" style={{ height: t.h }}>
                    <div className="Marketplace-Chart-barInner" style={{ height: t.inner }} />
                  </div>
                  <span className="Marketplace-Chart-month">{t.m}</span>
                </div>
              ))}
            </div>
            <div className="Marketplace-Chart-legend">
              <span className="Marketplace-Chart-legendItem">
                <span className="Marketplace-Chart-swatch Marketplace-Chart-swatch--solid" />
                {d.legendA}
              </span>
              <span className="Marketplace-Chart-legendItem">
                <span className="Marketplace-Chart-swatch Marketplace-Chart-swatch--soft" />
                {d.legendB}
              </span>
            </div>
          </div>

          <div className="Marketplace-card">
            <div className="Marketplace-cardTitle">{d.splitTitle}</div>
            <div className="Marketplace-Split-bar">
              <div className="Marketplace-Split-barA" style={{ width: d.splitAW }} />
              <div className="Marketplace-Split-barB" style={{ width: d.splitBW }} />
            </div>
            <div className="Marketplace-Split-rows">
              {d.splitRows.map((r) => (
                <div className="Marketplace-Split-row" key={r.id}>
                  <span className="Marketplace-Split-dot" style={{ background: r.color }} />
                  <div className="Marketplace-Split-rowInfo">
                    <div className="Marketplace-Split-rowLabel">{r.label}</div>
                    {r.sub && <div className="Marketplace-Split-rowSub">{r.sub}</div>}
                  </div>
                  <span className="Marketplace-Split-rowPct">{r.pct}</span>
                  <span className="Marketplace-Split-rowAmount">{r.amount}</span>
                </div>
              ))}
              {!d.splitRows.length && (
                <div className="Marketplace-empty">{d.emptyLabel || m.planEmptyBody}</div>
              )}
              {!!d.splitStats.length && <div className="Marketplace-Split-divider" />}
              <div className="Marketplace-Split-stats">
                {d.splitStats.map((s) => (
                  <div key={s.id}>
                    <div className="Marketplace-Split-statValue" style={{ color: s.color }}>
                      {s.value}
                    </div>
                    <div className="Marketplace-Split-statLabel">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

StatsBoard.propTypes = {
  data: PropTypes.object.isRequired,
  m: PropTypes.object.isRequired,
};

export default StatsBoard;
